// marketing-site/src/main.jsx
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import i18n from './i18n/index.js';

// Global Styles - ordem de importação é importante!
import './styles/tailwind.css';
import './styles/globals/reset.css';
import './styles/globals/variables.css';
import './styles/globals/base.css';
import './styles/globals/responsive.css';

// CRITICAL FIX: Sincronizar <html lang> com i18n globalmente
i18n.on('languageChanged', (lng) => {
  const normalizedLang = lng.toLowerCase().startsWith('en') ? 'en' : 'pt';
  document.documentElement.lang = normalizedLang;
  console.log('[i18n global] HTML lang atualizado para:', normalizedLang);
});

// Aplicar idioma inicial
const initialLang = i18n.language.toLowerCase().startsWith('en') ? 'en' : 'pt';
document.documentElement.lang = initialLang;
console.log('[i18n global] HTML lang inicial:', initialLang);

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
